import Analytics from 'utils/analytics';
import CommonStrings from 'resources/common-strings';
import CommonValues from 'resources/common-values';
import CreateReactClass from 'create-react-class';
import HelpBox from 'components/generic/help/index';
import { Immutable } from 'nuclear-js';
import PropTypes from 'prop-types';
import React from 'react';
import RuntimeActions from 'data/app-runtime/actions';
import Reactor from 'data/reactor';

import ExpandedReadabilityMeasures from './readability-measures';
import ExpandedMathabilityMeasures from './mathability-measures';
import ExpandedProficiencies from './proficiency';
import ExpandedGrowth from './growth-and-achievement';

export default CreateReactClass({
    displayName: 'ComparisonsExpandedContainer',

    propTypes: {
        selectedSubject: PropTypes.instanceOf(Immutable.Map),
        currentTestEvent: PropTypes.instanceOf(Immutable.Map),
        lexileRange: PropTypes.string,
        quantileRange: PropTypes.string,
        proficienciesToDisplay: PropTypes.instanceOf(Immutable.List),
        studentBid: PropTypes.string.isRequired,
        studentGrade: PropTypes.number.isRequired,
        studentFirstName: PropTypes.string.isRequired,
        studentGender: PropTypes.string.isRequired,
        subjectBid: PropTypes.number.isRequired,
        comparisonDropdownPeriods: PropTypes.instanceOf(Immutable.Map),
        defaultComparisonPeriodFunction: PropTypes.func,
        selectedComparisonPeriod: PropTypes.instanceOf(Immutable.Map),
        isUserNormData: PropTypes.bool,
        batchInfo: PropTypes.object /* Only exists when in Batch Print mode */,
        keystoneTestEvent: PropTypes.object,
    },

    onCollapse() {
        RuntimeActions.expandModule(null, null, true);
    },

    onTransitionEnd(event) {
        event.stopPropagation();
        Reactor.batch(() => {
            RuntimeActions.completeTransition();
            RuntimeActions.setAnimationIsRunning(false);
        });
    },

    helpText() {
        return (
            <div key="comparisons-expanded-help-content">
                <p key="initial-text"> {CommonStrings.comparisonsExpandedHelp.initialText} </p>
            </div>
        );
    },

    renderHeader() {
        return (
            <div className="header-wrapper" key="comparisons-header-container">
                <header key="comparisons-header">
                    <h5>Comparisons</h5>
                    <HelpBox
                        id={'comparisons-expanded-help-box-header'}
                        appLevelCssClassName=""
                        helpContentsRenderer={this.helpText}
                        moduleName={CommonValues.SectionIDs.comparisons}
                        helpLabel="comparisons-view-help"
                    />
                </header>
                <span
                    key="comparisons-collapse"
                    className="icon-collapse"
                    onClick={() => {
                        this.onCollapse();
                        Analytics.recordButtonClick(
                            CommonValues.SectionIDs.comparisons,
                            'close-module',
                            'comparisons-expanded'
                        );
                    }}
                >
                    {CommonStrings.collapse}
                </span>
            </div>
        );
    },

    renderReadabilityMeasures() {
        if (this.props.currentTestEvent && this.props.subjectBid === CommonValues.SUBJECT_BID_READING) {
            return (
                <ExpandedReadabilityMeasures
                    key="comparisons-expanded-readability-measures-module"
                    studentBid={this.props.studentBid}
                    lexileRange={this.props.lexileRange}
                    studentFirstName={this.props.studentFirstName}
                />
            );
        }
        return null;
    },

    renderMathabilityMeasures() {
        if (this.props.currentTestEvent && this.props.subjectBid === CommonValues.SUBJECT_BID_MATHEMATICS) {
            return (
                <ExpandedMathabilityMeasures
                    key="comparisons-expanded-mathability-measures-module"
                    studentBid={this.props.studentBid}
                    quantileRange={this.props.quantileRange}
                    studentFirstName={this.props.studentFirstName}
                />
            );
        }
    },

    renderProficiencies() {
        if (this.props.currentTestEvent) {
            return (
                <ExpandedProficiencies
                    subjectBid={this.props.subjectBid}
                    studentBid={this.props.studentBid}
                    studentFirstName={this.props.studentFirstName}
                    studentGender={this.props.studentGender}
                    studentGrade={this.props.studentGrade}
                    proficienciesToDisplay={this.props.proficienciesToDisplay}
                />
            );
        }
        return null;
    },

    renderGrowth() {
        if (this.props.currentTestEvent) {
            return (
                <ExpandedGrowth
                    selectedSubject={this.props.selectedSubject}
                    studentBid={this.props.studentBid}
                    subjectBid={this.props.subjectBid}
                    studentFirstName={this.props.studentFirstName}
                    studentGender={this.props.studentGender}
                    comparisonDropdownPeriods={this.props.comparisonDropdownPeriods}
                    defaultComparisonPeriodFunction={this.props.defaultComparisonPeriodFunction}
                    selectedComparisonPeriod={this.props.selectedComparisonPeriod}
                    isUserNormData={this.props.isUserNormData}
                    batchInfo={this.props.batchInfo}
                />
            );
        }
        return null;
    },

    renderNoTestEventText() {
        if (!this.props.currentTestEvent) {
            return (
                <p key="noTestEvents" className="text-no-test-events">
                    {CommonStrings.noTestEvents}
                </p>
            );
        }
        return null;
    },

    render() {
        const header = this.renderHeader();
        return (
            <div
                className="module comparisons expanded"
                key="expanded-comparisons-panel"
                onTransitionEnd={this.onTransitionEnd}
            >
                {header}
                <div className="comparisons-expanded-content" key="comparisons-container" style={{ width: '100%' }}>
                    <div className="comparisons-expanded-left" style={{ width: '60%' }}>
                        {this.renderNoTestEventText()}
                        {this.renderGrowth()}
                    </div>
                    <div className="comparisons-expanded-right" style={{ width: '40%' }}>
                        {this.renderProficiencies()}
                        {this.renderReadabilityMeasures()}
                        {this.renderMathabilityMeasures()}
                    </div>
                </div>
            </div>
        );
    },
});
